import { Component, Input, EventEmitter } from '@angular/core';

import type { HelpTranslationLinkMapKey } from '@core/help-articles-legacy';
import { HelpArticlesDirective } from '@core/help-articles-legacy';
import { TranslatePipe } from '@core/i18n-legacy';
import type { IconName } from '@core/user-interface-legacy';
import {
  ButtonComponent,
  DividerComponent,
  IconButtonComponent,
  IconColorDirective,
  IconComponent,
} from '@core/user-interface-legacy';

import type { WalkthroughComponentProperties } from '../../types';

@Component({
  selector: 'rt-walkthrough-post',
  imports: [
    IconButtonComponent,
    IconColorDirective,
    ButtonComponent,
    IconComponent,
    TranslatePipe,
    DividerComponent,
    HelpArticlesDirective,
  ],
  templateUrl: './walkthrough-post.component.html',
  styleUrl: './walkthrough-post.component.less',
})
export class WalkthroughPostComponent implements WalkthroughComponentProperties {
  @Input() public helpArticleKey?: HelpTranslationLinkMapKey;

  @Input() public currentStep: number;
  @Input() public stepsTotal: number;

  @Input() public heading: string;
  @Input() public description: string;

  @Input() public ctaText: string;
  @Input() public ctaIcon?: IconName = undefined;

  public cancel = new EventEmitter<void>();
  public finish = new EventEmitter<void>();
  public next = new EventEmitter<void>();

  public closeTooltip() {
    this.cancel.emit();
  }
}
